import { extendTheme } from '@chakra-ui/react';
import { oktonTheme } from '@okton/platform-ui';

// A base visual (cores, fontes, Menu, Modal, Button...) vem do Platform UI,
// comum a todos os sistemas Okton. Aqui fica só o que é do OktonBank.
export const theme = extendTheme(
  {
    components: {
      // A caixa vazia do Chakra não tem preenchimento e a borda herda a cor do
      // contexto: sobre a linha escolhida da Conciliação, que é azul clara, o
      // contraste ficava em 1,68 e ela quase sumia. Fundo sólido e borda de 2px
      // resolvem, com as cores medidas contra o fundo daquela linha nos dois
      // temas: 4,77 no claro e 5,59 no escuro — lá o fundo do cartão sozinho
      // também não bastava (1,03 contra a linha).
      Checkbox: {
        parts: ['control'],
        defaultProps: {
          colorScheme: 'blue',
        },
        baseStyle: ({ colorMode }: { colorMode: string }) => ({
          control: {
            borderWidth: '2px',
            bg: colorMode === 'light' ? 'white' : 'gray.900',
            borderColor: colorMode === 'light' ? 'gray.500' : 'gray.300',
            _hover: {
              borderColor: colorMode === 'light' ? 'blue.400' : 'blue.300',
            },
            _checked: {
              bg: 'blue.500',
              borderColor: 'blue.500',
              color: 'white',
              _hover: {
                bg: 'blue.600',
                borderColor: 'blue.600',
              },
            },
          },
        }),
      },
    },
  },
  oktonTheme,
);
